export { default } from "./PeopleGroupsTab";
